import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  timeField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: theme.spacing(0.5),
    },
    '& .MuiInputAdornment-positionEnd': {
      marginRight: theme.spacing(1),
      position: 'absolute',
      right: '2%',
      width: '22px',
      height: '22px',
      pointerEvents: 'none',
    },
    marginTop: 0,
    width: '100%',
    minWidth: '100px',
    '& input[value=""]': {
      marginRight: 0,
      paddingRight: theme.spacing(1.25),
    },
    '& input[value=""]:not(:focus-within)': {
      marginRight: 0,
      paddingRight: theme.spacing(1.25),
      color: 'transparent',
      '&:before': {
        height: '100%',
        content: '""',
        position: 'absolute',
        lineHeight: theme.spacing(3),
        opacity: '0.29',
      },
    },
    '& input[type="time"]::-webkit-calendar-picker-indicator': {
      width: theme.spacing(3),
      height: theme.spacing(3),
      background: 'none',
    },
    '& .Mui-disabled input[value=""]:not(:focus-within):before': {
      opacity: '0.25',
    },
  },
}));
